import { SaveButton } from "components/Buttons"
import { SingleSelectField, TextField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import React from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, reduxForm } from "redux-form"
import { generateCode } from "store/actions"

const required = value => (value?.toString() ? undefined : "Required")

const GenerateCode = ({ generateCode, handleSubmit }) => {
  return (
    <Card>
      <CardHeader style={{ backgroundColor: "lightGray" }}>
        <h5>Generate codes</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col>
            <Field
              name="type"
              component={SingleSelectField}
              options={[
                { label: "Physical", value: 0 },
                { label: "Digital", value: 1 },
              ]}
              label="Code Type"
              validate={[required]}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col>
            <Field
              name="codeWord"
              component={TextField}
              label="Code word"
              validate={[required]}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col>
            <Field
              name="numOfHosts"
              component={TextField}
              label="Number of Host Codes"
              validate={[required]}
            />
          </Col>
        </Row>
        <Row className="my-3">
          <Col>
            <Field
              name="numOfGuests"
              component={TextField}
              label="Number of Guest Codes per Host Code"
              validate={[required]}
            />
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Generate Codes"
              onClick={handleSubmit(data => {
                generateCode({
                  digital: data?.type,
                  guests: data?.numOfGuests,
                  hosts: data?.numOfHosts,
                  word: data?.codeWord,
                })
              })}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({
  generateCode: values => dispatch(generateCode(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.GENERATE_CODE })(GenerateCode))
